import { css } from '@emotion/react';
import { FaWindows } from 'react-icons/fa';

interface ButtonDownloadProps {
  href: string;
  label: string;
  sublabel: string;
}

export default function ButtonDownload({ href, label, sublabel }: ButtonDownloadProps) {
  return (
    <a css={styles.button} href={href} download>
      <FaWindows size={32} />
      <div css={styles.text}>
        <span>{label}</span>
        <small>{sublabel}</small>
      </div>
    </a>
  );
}

const styles = {
  button: css`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 26px;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
    background: linear-gradient(90deg, #00b4f0, #1466e8);
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 4px 18px rgba(0, 140, 230, 0.35);
    color: white;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 6px 24px rgba(0, 160, 240, 0.5);
      color: white;
    }

    svg {
      fill: #fff;
      margin-top: -4px;
    }
  `,

  text: css`
    display: flex;
    flex-direction: column;
    text-align: left;
    color: white;

    span {
      font-size: 17px;
      font-weight: 600;
    }

    small {
      font-size: 13px;
      opacity: 0.75;
    }
  `,
};
